<template>
    <div class="container">
        <alarm-record></alarm-record>
    </div>
</template>

<script>
import AlarmRecord from '../target/components/AlarmRecord';

export default {
    components: {
        AlarmRecord
    }
};
</script>
<style lang="scss" scoped>
.container {
    padding: 0 20px;
}
</style>